import cn from 'classnames';
import React from 'react';

import styles from './block-wrapper.module.scss';

export const BlockWrapper: React.FC<{
  className?: string;
  id?: string;
  children?: React.ReactNode;
}> = ({ className, children, id }) => (
  <div className={cn(styles.blockWrapper, className)} id={id}>
    {children}
  </div>
);
